import { render } from "./Footer.vue?vue&type=template&id=7734eff2"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Navigation/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7734eff2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7734eff2', __exports__)) {
    api.reload('7734eff2', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=7734eff2", () => {
    api.rerender('7734eff2', render)
  })

}


export default __exports__